import type { ComponentProps } from "react";
import { Icon, type IconComponent, type IconComponentProps, Interface1, TamaguiButton, XStack } from "@medbillai/ui";
type NavListItemProps = Omit<ComponentProps<typeof TamaguiButton>, "children" | "icon"> & {
  icon: IconComponent;
  label: string;
  active: boolean;
  // Overrides the active/subtle pair (e.g. a completion tick); also opts the
  // icon out of the hover recolor so a status color can't flicker away.
  iconColor?: IconComponentProps["color"];
};

// The nav-list row recipe shared by the global web sidebar and the FA wizard
// rail, so section navigation reads as one component family everywhere.
export const NavListItem = ({
  icon,
  label,
  active,
  iconColor,
  ...rest
}: NavListItemProps) => <TamaguiButton unstyled cursor="pointer" paddingHorizontal="$sp1.5" paddingVertical="$sp1" justifyContent="center" borderRadius="$br1" backgroundColor={active ? "$surface1Hover" : "$surface1"} transition="press" hoverStyle={{
  backgroundColor: "$surface1Hover"
}} pressStyle={{
  opacity: 0.8
}} focusVisibleStyle={{
  outlineWidth: "$si0.25",
  outlineColor: "$borderStrong",
  outlineStyle: "solid",
  outlineOffset: "$si0.25"
}} width="100%" height="$si5" group aria-current={active ? "page" : undefined} {...rest} data-sentry-element="TamaguiButton" data-sentry-component="NavListItem" data-sentry-source-file="NavListItem.tsx">
    <XStack gap="$2" alignItems="center" width="100%" data-sentry-element="XStack" data-sentry-source-file="NavListItem.tsx">
      <Icon icon={icon} size="$iconSmall" color={iconColor ?? (active ? "$iconDefault" : "$iconSubtle")} {...iconColor ? {} : {
      "$group-hover": {
        color: "$iconDefault"
      }
    }} data-sentry-element="Icon" data-sentry-source-file="NavListItem.tsx" />
      <Interface1 color={active ? "$textDefault" : "$textSubtle"} $group-hover={{
      color: "$textDefault"
    }} numberOfLines={1} data-sentry-element="Interface1" data-sentry-source-file="NavListItem.tsx">
        {label}
      </Interface1>
    </XStack>
  </TamaguiButton>;